import { FeedCommentInput } from '../atoms/CommentInput'
import { useCurrentFeedItem } from '../feedScroll'
import { ActionIcon, Text, View } from '@/components'
import { React, variantProvider } from '@/app'
import { replyStore, resetReplyState } from '@/stores/reply'
import { useCommentSubmit } from '../hooks'

export const FeedActionBar = () => {
  const form = FeedCommentInput.use()
  const item = useCurrentFeedItem()

  const replyContext = replyStore.use()
  const reply = replyContext?.reply

  const itemId = item?.id as number

  const { isSending, error, handleSubmit, clearError } = useCommentSubmit({
    itemId,
    value: form.values.text,
    onSuccess: () => form.setFieldValue('text', ''),
  })

  const previousTextRef = React.useRef(form.values.text)
  React.useEffect(() => {
    if (!error) {
      previousTextRef.current = form.values.text
      return
    }

    if (form.values.text !== previousTextRef.current) clearError()
    previousTextRef.current = form.values.text
  }, [form.values.text, error, clearError])

  const handleCloseReply = () => {
    resetReplyState()
    return
  }

  return <View variants={['padding:1.2', 'column', 'gap:1.2']} style={styles.wrapper}>
    {reply && (
      <View variants={['backgroundColor:neutral2', 'gap:1.2']} style={styles.replyWrapper}>
        <View variants={['column']}>
          <Text text='Replying to:' variants={['p2', 'regular', 'color:neutral5']} />
          <Text text={reply?.profile?.display_name} variants={['h5', 'bold', 'color:neutral9']} />
          <Text text={reply?.text} variants={['p3', 'regular', 'color:neutral9']} />
        </View>
        <ActionIcon onPress={handleCloseReply} name='x' variants={['minimal', 'iconSize:1', 'neutral5']} debugName='close button reply' />
      </View>
    )}
    <FeedCommentInput form={form} onSend={handleSubmit} loading={isSending} customError={error} />
  </View>
}

const styles = variantProvider.createComponentStyle(theme => ({
  wrapper: {
    ...theme.border.neutral3({
      width: `0.5px`,
      directions: ['top'],
    }),
  },
  replyWrapper: {
    ...theme.border.neutral3({
      width: `0.5px`,
    }),
    borderRadius: theme.borderRadius.tiny,
    ...theme.spacing.paddingHorizontal(2),
    ...theme.spacing.paddingVertical(1),
    ...theme.presets.row,
    ...theme.presets.justifySpaceBetween,
    ...theme.presets.alignCenter,
  },
}), true)
